import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import logo from '../Asset/crovate.png' // Path to your logo image

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
        {/* Replace the text with an image */}
        <img src={logo} alt="My Business Logo" className="logo-img" />
      </div>
      <input type="checkbox" id="menu-toggle" />
      <label htmlFor="menu-toggle" className="hamburger">&#9776;</label>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        {/* <li className="dropdown">
          <span>Services ▾</span>
          <ul className="dropdown-content">
            <li><Link to="/services/logo">Logo Design</Link></li>
            <li><Link to="/services/website">Website</Link></li>
            <li><Link to="/services/template">Template</Link></li>
            <li><Link to="/services/poster">Poster</Link></li>
          </ul>
        </li> */}
        <li className="dropdown">
          {/* Wrap Services text in Link */}
          <Link to="/services" className="services-link">Services ▾</Link>
          
          <ul className="dropdown-content">
            <li><Link to="/services/logo">Logo Design</Link></li>
            <li><Link to="/services/website">Website</Link></li>
            <li><Link to="/services/template">Template</Link></li>
            <li><Link to="/services/poster">Poster</Link></li>
          </ul>
        </li>
        {/* <li><Link to="/contact">Contact</Link></li> */}
        <li><Link to="/login">Login</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
